module.exports = __webpack_public_path__ + "img/www-pana.e9c6aecd.png";